/*
* Display status message (so far general activity and error messages)
* Note that activity messages are delayed by the css transition-delay amount
* so they only appear if the activity continues for awhile
*/

<template>
  <div
    class="statusMessage"
    :class="{ showing : isMessage, activity : isActivity, error : isError, info : isInfo }"
    @click="maybeClose"
  >
    <div
      v-if="isMessage"
      class="message"
    >
      <div
        v-if="isActivity"
        class="messageSpinnerContainer"
      >
        <Spinner />
      </div>
      <span>{{ message }}</span>
    </div>
    <div
      v-if="isError || isInfo"
      class="messageClose"
    />
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import * as types from '../store/mutation-types'
import * as messageTypes from '../constants/message-types'
import Spinner from './Spinner'

export default {
  name: 'StatusMessage',
  components: {
    Spinner,
  },
  data: function () {
    return {
      messageTimerID: false,
    }
  },
  computed: {
    ...mapState({
      statusMessage: state => state.appFrame.statusMessage,
    }),
    ...mapGetters(['getWindow']),
    isMessage: function () {
      return this.statusMessage && this.statusMessage.message.length
    },
    message: function () {
      return this.isMessage && this.statusMessage.message
    },
    isActivity: function () {
      return this.isMessage && this.statusMessage.type === messageTypes.ACTIVITY_MESSAGE
    },
    isError: function () {
      return this.isMessage && this.statusMessage.type === messageTypes.ERROR_MESSAGE
    },
    isInfo: function () {
      return this.isMessage && this.statusMessage.type === messageTypes.INFO_MESSAGE
    },
  },
  watch: {
    statusMessage: function (message) {
      if (this.messageTimerID) {
        this.getWindow.clearTimeout(this.messageTimerID)
        this.messageTimerID = null
      }

      // is this a message with a duration?
      if (message && message.duration) {
        this.messageTimerID = this.getWindow.setTimeout(this.closeMessage, message.duration)
      }
    },
  },
  beforeDestroy: function () {
    // don't keep message around on a context switch
    this.closeMessage()

    // don't want a timer firing after we're dead and gone
    if (this.messageTimerID) {
      this.getWindow.clearTimeout(this.messageTimerID)
      this.messageTimerID = null
    }
  },
  methods: {
    closeMessage: function () {
      this.$store.commit(types.SET_STATUS_MESSAGE, null)

      if (this.messageTimerID) {
        this.getWindow.clearTimeout(this.messageTimerID)
        this.messageTimerID = null
      }
    },
    maybeClose: function () {
      if (this.isError || this.isInfo) {
        this.closeMessage()
      }
    },
  },
}

</script>
